export default {
  outList: [
    {
      light_point_1:[
        {
          title: '凌眸LED大灯',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: ''
        },
      ],
      light_point_2:[
        {
          title: '锋齿点阵格栅+',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: ''
        },
      ],
      light_point_3:[
        {
          title: '虎耳示廓灯',
          type: 'image',
          video: '',
          image: 'lightPoint/1/5.jpg',
          text: ''
        }
      ],
      light_point_4:[
        {
          title: '鲲鹏动力 2.0TGDI发动机',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '254Ps马力，390N·m峰值扭矩，全栈自研“中国心”十佳发动机'
        }
      ],
      light_point_5:[
        {
          title: '越级大空间',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '更大的空间，装得下一家人的出行'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: 'AI大模型智慧交互',
          type: 'image',
          video: '',
          image: 'lightPoint/2/4.jpg',
          text: '全时免唤醒，方言免切换，流式语音识别',
          text2: '注：首批用户限时赠送"AI故事、AI画师"6个月免费使用权益'
        },
      ],
      light_point_2:[
        {
          title: '15.6吋2.5K高清大屏',
          type: 'image',
          video: '',
          image: 'lightPoint/2/5.jpg',
          text: '科技智慧大屏，信息一目了然'
        },
      ],
      light_point_3:[
        {
          title: '零重力女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: '一键舒躺SPA级享受'
        },
      ],
      light_point_4:[
        {
          title: 'SONY 14扬环绕音响（含头枕音响）',
          type: 'image',
          video: '',
          image: 'lightPoint/2/6.jpg',
          text: '环抱式音律氛围灯，聚合多媒体',
          text2: '沉浸式环绕感受'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '虎啸前脸',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: ''
    },
    {
      title: '锋齿点阵格栅+',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: ''
    },
    {
      title: '虎跃车身',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: ''
    },
    {
      title: '凌眸LED大灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: ''
    },
    {
      title: '虎耳示廓灯',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: ''
    }

  ],
  tab2: [
    {
      title: '越级大空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '更大的空间，装得下一家人的出行'
    },
    {
      title: '零重力女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '一键舒躺SPA级享受'
    },
    {
      title: 'B柱出风口/二排独立空调控制',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '舒享后排'
    },
    {
      title: 'AI大模型智慧交互',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '全时免唤醒，方言免切换，流式语音识别',
      text2: '注：首批用户限时赠送"AI故事、AI画师"6个月免费使用权益'
    },
    {
      title: '15.6吋2.5K高清大屏',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '科技智慧大屏，信息一目了然'
    },
    {
      title: 'SONY 14扬环绕音响（含头枕音响）',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '环抱式音律氛围灯，聚合多媒体',
      text2: '沉浸式环绕感受'
    }
  ],
  tab3: [
    {
      title: '鲲鹏动力 2.0TGDI发动机',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '254Ps马力，390N·m峰值扭矩，全栈自研“中国心”十佳发动机'
    },
    {
      title: '鲲鹏8AT变速箱',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '中国主流品牌首款量产8AT'
    },
    {
      title: '全场景 智控四驱系统',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '7种驾驶模式，驰骋雪地、泥地、沙地，等17种以上地形路况'
    },
  ],
  tab4: [
    {
      title: '「磐石」车身',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '高强度钢占比85%，热成型钢占比21%，双防撞梁+6吸能盒'
    },
    {
      title: '全车7气囊',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '2060mm帘式气囊，超长6s保压'
    },
    {
      title: 'L2.5级智能辅助驾驶系统',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '19项智能驾驶辅助 ，540°全景高清影像'
    },
  ]
}
